import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FieldSelector from 'components/FieldSelector/FieldSelector';

var InspectionData = function (props) {
  var config = props.config;
  var settingsFields = props.settingsFields;
  var onRecordsFieldChange = props.onRecordsFieldChange;
  var errors = props.errors || {};
  var t = useTranslation().t;

  return (
    <div className="inspect-section-inspection-data">
      <div className="inspect-settings-content-header">
        <h3 className="inspect-settings-content-title">{t('inspect:sectionInspectionData')}</h3>
        <p className="inspect-settings-content-description">{t('inspect:inspectionDataDescription')}</p>
      </div>

      <p className="inspect-mode-hint">{t('inspect:inspectionTargetRecordsHint')}</p>
      <FieldSelector
        currentSUUID={config.recordsFieldKey || ''}
        fields={settingsFields}
        onChange={onRecordsFieldChange}
        error={!!errors.inspectionRecordsFieldPathHash}
      />
      {errors.inspectionRecordsFieldPathHash && (
        <div className="slate-text-input-error">{errors.inspectionRecordsFieldPathHash}</div>
      )}
    </div>
  );
};

InspectionData.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  settingsFields: PropTypes.array.isRequired,
  onRecordsFieldChange: PropTypes.func.isRequired,
};

export default InspectionData;
